import { Clock3, FileCheck2 } from "lucide-react";
import { PageHeading } from "../components/PageHeading";
import { usePortal } from "../context/PortalContext";
import { formatDate } from "../lib/format";

export function HistoryPage() {
  const { track } = usePortal();
  if (!track) return <div className="loading-state">正在读取学习记录</div>;
  return (
    <>
      <PageHeading number="09" title="学习与建设记录" description="这里保留轨道内的学习、测评、资料接入和教材建设。活动时长不能直接当作你的纯学习时长。" />
      <div className="history-timeline">{track.sessions.map((session, index) => <article key={session.id}><div className="history-date"><span>{String(index + 1).padStart(2, "0")}</span><time>{formatDate(session.occurred_at, true)}</time></div><div className="history-minutes"><Clock3 size={16} /><strong>{session.minutes}</strong><span>分钟</span></div><div className="history-body"><h2>{session.summary}</h2>{session.blockers.length > 0 && <p className="history-blocker">阻塞：{session.blockers.join("；")}</p>}<p><b>下一步：</b>{session.next_action || "未记录"}</p>{session.artifacts.length > 0 && <div className="history-artifacts"><FileCheck2 size={16} />{session.artifacts.map((artifact) => <span key={artifact}>{artifact.split("/").pop()}</span>)}</div>}</div></article>)}</div>
    </>
  );
}
